export const phoneMask = {
  mask: "(__) _____-____",
  replacement: { _: /\d/ },
  modify: (input: string) => {
    return { mask: input.length < 11 ? "(__) ____-_____" : undefined };
  },
};

export const cpfMask = {
  mask: "___.___.___-__",
  replacement: { _: /\d/ },
};

export const cepMask = {
  mask: "_____-___",
  replacement: { _: /\d/ },
};

export const cnpjMask = {
  mask: "__.___.___/____-__",
  replacement: { _: /\d/ },
};

/*
export const rgMask = useMask({
    mask: "00.000.000",
    replacement: { 0: /\d/ },
});
*/
export const numberMask = {
  mask: "_______",
  replacement: { _: /\d/ },
};
export const cpfCnpjMask = {
  mask: "___.___.___-__",
  replacement: { _: /\d/ },
};
